import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { patHoberg } from "@/lib/celebrity-results/pat-hoberg";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Pat Hoberg Hair Transplant Results | RESTORE® Hair";
const DESC = "See MLB umpire Pat Hoberg's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-09-mlbumpiresportraits-048-v2-2-1.webp";

export const Route = createFileRoute("/results/pat-hoberg")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/pat-hoberg/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/pat-hoberg/" },
    ],
  }),
  component: () => <CelebrityResultPage data={patHoberg} />,
});
